import React from "react";
import { BlockStack } from "@shopify/polaris";
import CommentItem from "./CommentItem";

export default function CommentsList({
  comments,
  onUpdate,
  onDelete,
  taskId,
  onSent,
}) {
  return (
    <>
      {comments.map((comment) => (
        <CommentItem
          key={comment.id}
          comment={comment}
          onUpdate={onUpdate}
          onDelete={onDelete}
          taskId={taskId}
          onSent={onSent}
        />
      ))}
    </>
  );
}
